document.querySelectorAll('.mobile-menu').forEach(menu => {
  menu.addEventListener('keydown', event => {
    if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
  });
  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
  document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
});
document.querySelectorAll('.product-form').forEach(form => {
  form.addEventListener('change', event => {
    if (event.target.matches('[data-variant-price]')) {
      form.closest('.product-copy').querySelector('[data-product-price]').textContent = event.target.dataset.variantPrice;
    }
  });
});
document.querySelectorAll('.form-success').forEach(message => message.focus());

const launchInterest = document.querySelector('#waitlist-interest');
if (launchInterest) {
  const requestedInterest = new URLSearchParams(window.location.search).get('interest');
  const option = Array.from(launchInterest.options).find(item => item.dataset.interest === requestedInterest);
  if (option) launchInterest.value = option.value;
  document.querySelectorAll('[data-launch-interest]').forEach(link => {
    link.addEventListener('click', event => {
      const selected = Array.from(launchInterest.options).find(item => item.dataset.interest === link.dataset.launchInterest);
      if (!selected) return;
      event.preventDefault();
      launchInterest.value = selected.value;
      document.querySelector('#waitlist').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      launchInterest.focus({ preventScroll: true });
    });
  });
}

document.querySelectorAll(".bundle-choice").forEach(choice => {
  choice.addEventListener("change", event => {
    if (event.target.matches("[data-bundle-price]")) {
      choice.querySelector("[data-bundle-total]").textContent = event.target.dataset.bundlePrice;
    }
  });
});
